'use strict';

define('share-article',['jquery'], function ($) {

  var $shareArticleList = $('.share-article__list'),
      $shareArticleListLink = $shareArticleList.find('a');

  var handlers = {
    shareArticleListClick: function() {
      $(this).toggleClass('expanded');
    },

    documentClick: function(event) {
      if(!$(event.target).closest($shareArticleList).length) {
        if($shareArticleList.is(':visible')) {
          $shareArticleList.removeClass('expanded');
        }
      }
    },

    shareArticleListLinkClick: function() {
      var windowObjectReference;
      var strWindowFeatures = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=300,height=350';
      windowObjectReference = window.open(this.href, 'intent', strWindowFeatures);

      //First check if the browser supports the focus() method, if so place the focus on the new window.
      if (window.focus) {
        windowObjectReference.focus();
      }

      //This is to prevent the browser from following the actual link.
      return false;
    }
  };

  var initialize = function() {
    attachEvents();
  };

  var attachEvents = function() {
    $shareArticleList.click(handlers.shareArticleListClick);

    // Close share list if click is made outside element
    $(document).on('click.shareArticle', handlers.documentClick);

    // Open social share in a popup window
    $shareArticleListLink.click(handlers.shareArticleListLinkClick);
  };

  return {
    init: initialize
  };

});
